import './FileThumbnail.scss';

export { default } from './FileThumbnail';
